
export const processAsJson = (value, mock = {}) => {
    try {
        if (value === null || typeof value === 'boolean') throw new Error();
        return JSON.parse(value);
    } catch (e) {
        console.error('Cannot parse JSON');
        return mock;
    }
};